import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { NotificationList } from "../../app/generated-axios-client";

interface NotificationState {
  list: NotificationList[];
  technicianIds: number[];
  loading: boolean;
  error: string | null;
}

const initialState: NotificationState = {
  list: [],
  technicianIds: [],
  loading: false,
  error: null,
};

export const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    fetchNotifications: (state) => {
      state.loading = true;
      state.error = null;
    },
    storeNotifications: (
      state,
      action: PayloadAction<{ list: NotificationList[]; technicianIds: number[] }>
    ) => {
      state.list = action.payload.list;
      state.technicianIds = action.payload.technicianIds;
      state.loading = false;
      state.error = null;
    },
    setNotificationsError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.loading = false;
    },
    requestMarkRead: (_state, _action: PayloadAction<string[]>) => {},
    markNotificationsRead: (state, action: PayloadAction<string[]>) => {
      const ids = new Set(action.payload);
      const now = new Date().toISOString();
      state.list = state.list.map((n) =>
        n.id && ids.has(n.id) && !n.read_at ? { ...n, read_at: now } : n
      );
    },
  },
});

export const notificationActions = notificationSlice.actions;
export default notificationSlice.reducer;
